import DataMap from '../classes/data-map';

/**
 * Class representing the HousingReport Map.
 */
export default class HousingReportMap {
    DataPageInstance;
    DataMapInstance;

    /**
     * Create a HousingReportMap instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        this.DataMapInstance = new DataMap('.mapbox');
    }

    /**
     * Set map data on the map instance.
     * @param {Object|string} mapData - The map data to be set on the map.
     * @example
     * // Set map data
     * setMap(mapData);
     */
    setMap(mapData) {
        try {
            JSON.parse(mapData);
        } catch (e) {
            return false;
        }

        const requestData = this.DataPageInstance.getGeoRequestParams();
        this.DataMapInstance.selectArea(
            JSON.parse(mapData),
            requestData.geoId,
            requestData.geoType,
        );
    }

    resize() {
        this.DataMapInstance.resize();
    }
}
